const FIELDS = [
  ["full_name", "Full name", "Aria Mehta", true],
  ["phone", "Phone", "98765 43210", true],
  ["line1", "Address line 1", "Flat / House, Street", true],
  ["line2", "Address line 2", "Area, Landmark (optional)", false],
  ["city", "City", "Hyderabad", true],
  ["state", "State", "Telangana", true],
  ["postal_code", "PIN code", "500001", true],
  ["country", "Country", "India", true],
];

export const AddressFields = ({ value, onChange }) => (
  <div data-testid="delivery-address">
    <div className="hy-label mb-3">Delivery address for the framed certificate</div>
    <p className="text-xs text-slate-500 mb-5 leading-relaxed">
      Every edition includes a physical photo-framed certificate, posted to this address. Your digital
      registry record, certificate and QR verification are included at no extra cost.
    </p>
    <div className="grid sm:grid-cols-2 gap-4">
      {FIELDS.map(([key, label, placeholder, required]) => (
        <label key={key} className={key.startsWith("line") ? "sm:col-span-2" : ""}>
          <span className="hy-label text-[0.55rem]">{label}</span>
          <input required={required} value={value[key] || ""} placeholder={placeholder}
            onChange={(e) => onChange({ ...value, [key]: e.target.value })}
            className="hy-input mt-2" data-testid={`address-${key.replace("_", "-")}`} />
        </label>
      ))}
    </div>
  </div>
);
